
import { Box, Typography } from "@mui/material";

import { loomEmbedUrl } from "./embed-utils";

import type { WidgetProps } from "./types";

export function LoomEmbed({ widget }: WidgetProps<"loom_embed">) {
    const src = loomEmbedUrl(widget.props.url);
    return (
        <Box>
            <Box
                sx={{
                    position: "relative",
                    pb: "56.25%", // 16:9
                    height: 0,
                    overflow: "hidden",
                    borderRadius: "10px",
                    bgcolor: "grey.900",
                }}
            >
                <Box
                    component="iframe"
                    src={src}
                    allowFullScreen
                    sx={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        border: 0,
                    }}
                />
            </Box>
            {widget.props.caption && (
                <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 1 }}>
                    {widget.props.caption}
                </Typography>
            )}
        </Box>
    );
}
